var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Stack } from "@mui/material";
import { useMemo, useState } from "react";
import LoadingContext from "./contexts/Loading";
import { RouterManager } from "./routes/RouterManager";
export var App = function () {
    var _a = useState(false), isLoading = _a[0], setIsLoading = _a[1];
    var obj = useMemo(function () { return ({ isLoading: isLoading, setIsLoading: setIsLoading }); }, [isLoading]);
    return (_jsx(LoadingContext.Provider, __assign({ value: obj }, { children: _jsx(Stack, __assign({ direction: "column" }, { children: _jsx("div", __assign({ className: "max-w-screen-5xl mx-auto mt-4 flex flex-col font-sans" }, { children: _jsx(RouterManager, {}) })) })) })));
};
